import { Route } from '@angular/router';
import { IntakeDashboardComponent } from './pages/intake-dashboard/intake-dashboard.component';
import { DescopeComponent } from './components/descope/descope.component';
import { authGuard } from './guards/auth.guard';
import { AddUserComponent } from './pages/add-user/add-user.component';
import { UserApplicationComponent } from './pages/user-application/user-application.component'; // Import new component
import { UserApplicationReportComponent } from './pages/user-application-report/user-application-report.component';

export const appRoutes: Route[] = [
  { path: 'login', component: DescopeComponent },
  {
    path: 'intake', component: IntakeDashboardComponent,
    canActivate: [authGuard]
  },
  {
    path: 'intake/application/:userId', component: UserApplicationReportComponent,
    canActivate: [authGuard]
  },
  {
    path: 'intake/user/:userId', component: UserApplicationComponent,
    canActivate: [authGuard]
  },
  {
    path: 'add-user', component: AddUserComponent,
    canActivate: [authGuard]
  },
  {
    path: '**', redirectTo: 'login'
  }
];